const normalizePattern = (pattern) => {
  const raw = Array.isArray(pattern) ? pattern : [200, 80, 200];
  const normalized = raw
    .map((n) => Number(n))
    .filter((n) => Number.isFinite(n) && n > 0)
    .map((n) => Math.min(2000, Math.max(20, Math.round(n))));
  return normalized.length ? normalized : [200, 80, 200];
};

export async function triggerAlertVibration(pattern = [200, 80, 200]) {
  const finalPattern = normalizePattern(pattern);

  try {
    const iosBridge = window?.webkit?.messageHandlers?.nativeBridge;
    if (iosBridge?.postMessage) {
      iosBridge.postMessage({
        action: "vibrate",
        pattern: finalPattern,
      });
      return true;
    }
  } catch {}

  try {
    const didVibrate = navigator?.vibrate?.(finalPattern);
    if (didVibrate) return true;
  } catch {}

  try {
    const haptics = window?.Capacitor?.Plugins?.Haptics;
    if (haptics?.vibrate) {
      await haptics.vibrate();
      return true;
    }
    if (haptics?.impact) {
      await haptics.impact({ style: "MEDIUM" });
      return true;
    }
  } catch {}

  return false;
}
